import React from "react"
import { Pressable, StyleSheet, Text, View } from "react-native"
import { theme } from "@common/theme/theme"
import { pressOnSpace } from "../utils/pressOnSpace"

/**
 * Les réponses toutes faites de « Début des cours », côte à côte : un titre,
 * la date du premier cours, et ce que ce démarrage fait régler.
 *
 * `options` : `{ key, title, date, caption }`. Une seule réponse donne une
 * seule carte, pleine largeur. `selectedKey` vaut `null` quand le parent a
 * choisi une autre date : aucune carte n'est cochée.
 */
const StartOptionCards = ({
    options = [],
    selectedKey = null,
    groupLabel = "Date de démarrage",
    onSelect,
}) => (
    <View role="radiogroup" aria-label={groupLabel} style={styles.row}>
        {options.map((option) => {
            const selected = option.key === selectedKey
            const press = () => onSelect?.(option.key)
            return (
                <Pressable
                    key={option.key}
                    role="radio"
                    aria-checked={selected}
                    onPress={press}
                    {...pressOnSpace(press)}
                    style={[styles.card, selected && styles.cardOn]}
                >
                    <Text style={styles.title}>{option.title}</Text>
                    <Text style={styles.date}>{option.date}</Text>
                    {option.caption ? (
                        <Text style={styles.caption}>{option.caption}</Text>
                    ) : null}
                </Pressable>
            )
        })}
    </View>
)

const styles = StyleSheet.create({
    row: { flexDirection: "row", gap: 8 },
    card: {
        flex: 1,
        minWidth: 0,
        borderWidth: 2,
        borderColor: theme.colors.lightMore,
        borderRadius: 12,
        backgroundColor: theme.colors.white,
        paddingVertical: 10,
        paddingHorizontal: 12,
        gap: 2,
    },
    cardOn: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primaryLighter,
    },
    title: {
        fontFamily: "Montserrat-SemiBold",
        fontSize: 11.5,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
    date: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 15,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
    caption: {
        fontFamily: "Montserrat-Medium",
        fontSize: 11.5,
        lineHeight: 15,
        color: theme.colors.grey,
    },
})

export default StartOptionCards
